module.exports = __webpack_public_path__ + "img/mobile_banking.52522a8a.png";